export default __webpack_public_path__ + "static/media/480_private03-nl-web.3878808b.png";